export enum LaboratoryPermissionType {
  ApproveTests = "approveTests",
  CreateTests = "createTests",
  ManageUsers = "manageUsers",
  PerformTests = "performTests",
  ProcessTests = "processTests",
}

export interface LaboratoryPermission {
  laboratoryId: string;
  permissions: LaboratoryPermissionType[];
}

export interface UserPermissionProfile {
  isUserAdmin: boolean;
  laboratoryPermissions: LaboratoryPermission[];
}

export interface UserPermission {
  email: string;
  permissions: LaboratoryPermissionType[];
}

export interface LaboratoryManagers {
  laboratoryId: string;
  name: string;
  managers: string[];
}
